import { render } from "./LetterUpdateDialog.vue?vue&type=template&id=2a9a7f02&scoped=true"
import script from "./LetterUpdateDialog.vue?vue&type=script&lang=js"
export * from "./LetterUpdateDialog.vue?vue&type=script&lang=js"

import "./LetterUpdateDialog.vue?vue&type=style&index=0&id=2a9a7f02&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a7f02"]])

export default __exports__